// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "c4d8514f0108b336b782" + "/js/" + chunkId + ".js";
};